import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openCookies() {
    if (window.openAxeptioCookies) window.openAxeptioCookies()
  }
}
